export default "__VITE_PUBLIC_ASSET__70824d67__"